import type {
  FunctionComponent,
  MouseEvent as ReactMouseEvent,
  PropsWithChildren,
} from 'react';
// eslint-disable-next-line @atlaskit/design-system/no-unsupported-drag-and-drop-libraries
import { DndProvider } from 'react-dnd';
// eslint-disable-next-line @atlaskit/design-system/no-unsupported-drag-and-drop-libraries
import { HTML5Backend } from 'react-dnd-html5-backend';

import { TrelloIntlProvider } from '@trello/i18n/provider';

import { globalClickHandler } from 'app/src/globalClickHandler';

/**
 * NOTE:
 * If you are building components in the new GraphQL stack, you should be
 * using the renderComponent/ComponentWrapper combination. This react root
 * is for legacy React components in the classic stack only
 */

export const ReactRootComponent: FunctionComponent<
  PropsWithChildren<unknown>
> = ({ children }) => {
  const onClick = (e: ReactMouseEvent) => {
    if (e.isDefaultPrevented()) {
      return;
    }
    globalClickHandler(e);
  };

  return (
    <DndProvider backend={HTML5Backend}>
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
      <div
        className="js-react-root"
        // eslint-disable-next-line react/jsx-no-bind
        onClick={onClick}
      >
        <TrelloIntlProvider>{children}</TrelloIntlProvider>
      </div>
    </DndProvider>
  );
};
